// src/utils/storage.js
const FAVORITES_KEY = 'iptv_favorites';
const RECENT_CHANNELS_KEY = 'recent_channels';
const SETTINGS_KEY = 'iptv_settings';
const MAX_RECENT_CHANNELS = 10;

export const StorageService = {
  // Favoritos
  getFavorites: () => {
    try {
      const favorites = localStorage.getItem(FAVORITES_KEY);
      return favorites ? JSON.parse(favorites) : [];
    } catch (error) {
      console.error('Erro ao ler favoritos:', error);
      return [];
    }
  },
  
  addFavorite: (channel) => {
    try {
      const favorites = StorageService.getFavorites();
      // Verifica se o canal já está nos favoritos
      if (!favorites.some(fav => fav.id === channel.id)) {
        favorites.push(channel);
        localStorage.setItem(FAVORITES_KEY, JSON.stringify(favorites));
      }
      return favorites;
    } catch (error) {
      console.error('Erro ao adicionar favorito:', error);
      return [];
    }
  },
  
  removeFavorite: (channelId) => {
    try {
      const favorites = StorageService.getFavorites();
      const updated = favorites.filter(channel => channel.id !== channelId);
      localStorage.setItem(FAVORITES_KEY, JSON.stringify(updated));
      return updated;
    } catch (error) {
      console.error('Erro ao remover favorito:', error);
      return [];
    }
  },
  
  isFavorite: (channelId) => {
    try {
      const favorites = StorageService.getFavorites();
      return favorites.some(channel => channel.id === channelId);
    } catch (error) {
      console.error('Erro ao verificar favorito:', error);
      return false;
    }
  },
  
  // Canais recentes
  getRecentChannels: () => {
    try {
      const recentChannels = localStorage.getItem(RECENT_CHANNELS_KEY);
      return recentChannels ? JSON.parse(recentChannels) : [];
    } catch (error) {
      console.error('Erro ao recuperar canais recentes:', error);
      return [];
    }
  },
  
  addRecentChannel: (channel) => {
    try {
      const recentChannels = StorageService.getRecentChannels();
      
      // Remove o canal se já existir na lista
      const filteredChannels = recentChannels.filter(c => c.id !== channel.id);
      
      // Adiciona o canal no início da lista
      filteredChannels.unshift(channel);
      
      // Mantém apenas os últimos MAX_RECENT_CHANNELS canais
      const updatedChannels = filteredChannels.slice(0, MAX_RECENT_CHANNELS);
      
      localStorage.setItem(RECENT_CHANNELS_KEY, JSON.stringify(updatedChannels));
      
      return updatedChannels;
    } catch (error) {
      console.error('Erro ao adicionar canal recente:', error);
      return [];
    }
  },
  
  clearRecentChannels: () => {
    try {
      localStorage.removeItem(RECENT_CHANNELS_KEY);
    } catch (error) {
      console.error('Erro ao limpar canais recentes:', error);
    }
  },
  
  // Configurações
  getSettings: () => {
    try {
      const settings = localStorage.getItem(SETTINGS_KEY);
      return settings ? JSON.parse(settings) : {
        playerQuality: 'auto',
        autoplay: true,
        darkMode: false
      };
    } catch (error) {
      console.error('Erro ao ler configurações:', error);
      return {
        playerQuality: 'auto',
        autoplay: true,
        darkMode: false
      };
    }
  },
  
  updateSettings: (newSettings) => {
    try {
      const currentSettings = StorageService.getSettings();
      const updated = { ...currentSettings, ...newSettings };
      localStorage.setItem(SETTINGS_KEY, JSON.stringify(updated));
      return updated;
    } catch (error) {
      console.error('Erro ao atualizar configurações:', error);
      return null;
    }
  }
};

export default StorageService;